/* eslint-env browser */
/* globals $ */

// eslint-disable-next-line no-unused-vars
function init(options) {
  let {
    unlimited,
    numberAttempts,
    contentId,
    resourceId,
    canBeGraded,
  } = options;

  let attempts = 0;
  // let dataindex = 0; //dead?
  // Are we in a resource collection?
  // Should this be moved to our caller?
  let inCollection = false;

  let attemptTxt = '';
  let attemptsRemain;

  try {
    inCollection = typeof (window.parent && window.parent.clearAssessment) !== 'undefined';
    window.attempts = attempts;
  } catch (e) {
    inCollection = false;
  }

  $('#q_block_ordering').addClass('d-none').removeClass('hidden');

  function attemptFeedback() {
    if (unlimited) {
      attemptTxt = '';
    } else if (attemptsRemain > 1) {
      attemptTxt = `<h5>You have ${attemptsRemain} attempts remaining, please remain in the current browser session to utilise these.</h5>`;
    } else if (attemptsRemain === 1) {
      attemptTxt = `<h5>You have ${attemptsRemain} attempt remaining, please remain in the current browser session to utilise this.</h5>`;
    } else {
      attemptTxt = '<h5>You have 0 attempts remaining.</h5>';
    }
    $('#ordering_attempts').html(attemptTxt);
  }

  function mark(resultObject) {
    const result = { ...resultObject };
    attempts += 1;
    if (inCollection) { window.attempts = attempts; }

    // set #ordering_attempts text
    attemptsRemain = numberAttempts - attempts;
    attemptFeedback();

    if (result.feedback.incorrectIds) {
      result.feedback.incorrectIds.forEach((item) => {
        const div = $(`#${item}`);
        div.children('i').remove();
        div.prepend('<span class="visually-hidden">Incorrect - </span><i class="fa fa-times-circle float-right g-color-white" aria-hidden="true"></i>');
        div.removeClass('g-color-white bg-success');
        div.addClass('g-color-white bg-danger');
      });
    } else result.feedback.incorrectIds = [];

    if (result.feedback.correctIds) {
      result.feedback.correctIds.forEach((item) => {
        const div = $(`#${item}`);
        div.children('i').remove();
        div.prepend('<span class="visually-hidden">Correct - </span><i class="fa fa-check-circle float-right g-color-white" aria-hidden="true"></i>');
        div.removeClass('g-color-white bg-danger');
        div.addClass('g-color-white bg-success');
      });
    } else result.feedback.correctIds = [];

    $('#ordering_q_fb2').removeClass('d-none');

    if (!unlimited && attempts >= numberAttempts) {
      $('#ordering_sortable1 li').each(function disableElements() {
        $(this).addClass('ui-state-disabled');
      });
      $('#ordering_q_check2').addClass('d-none');
    }

    // set feedback card text
    const fbTxt = `<h2 class="h4">You matched ${result.feedback.correctIds.length} correctly and ${result.feedback.incorrectIds.length} incorrectly.</h2>`;
    const generalFb = `<p class="text-white"><strong>General Feedback:</strong> ${result.feedback.overall.replace(/(<p[^>]+?>|<p>|<\/p>)/img, '')}</p>`;
    $('#ordering_q_fb2 .card-text').html(fbTxt).append(generalFb);
    if (unlimited || attempts < numberAttempts) {
      // if attempts remain show the reset button, else show correct responses button
      $('#ordering_q_new2').removeClass('d-none');
    } else {
      $('#ordering_q_new2').addClass('d-none');
      if (result.correct.toString() !== 'true') {
        $('#ordering_show_answers').removeClass('d-none');
      }
    }
    // fix the content from 'jumping'
    if ($('#order_floater .row').outerHeight() > 0) {
      $('#order_floater').height($('#order_floater .row').outerHeight());
    }
    $('#q_skip2').addClass('d-none');
  }

  window.ordering_mark = mark;

  function startOrdering() {
    $('#q_block_ordering').removeClass('d-none');
    $('#ordering_q_fb2').addClass('d-none');
    $('#ordering_q_new2').addClass('d-none');
    $('#q_block_ordering').addClass('d-none');

    function newQuestion2(command) {
      if (command === 'new') {
        // first load
        $('#ordering_q_fb2').addClass('d-none');
        $('#ordering_q_new2').addClass('d-none');
        $('#ordering_show_answers').addClass('d-none');
        $('#ordering_sortable1').randomize('li');
        $('#targets').randomize('div.ordering_targetZone');
        $('#q_block_ordering').removeClass('d-none');
        $('#ordering_access').removeClass('d-none');
        $('#ordering_q_check2').removeClass('d-none');
        $('#q_skip2').removeClass('d-none');
      } else if (command === 'reset') {
        $('#ordering_q_fb2').addClass('d-none');
       $('#ordering_q_new2').addClass('d-none');
      $('.list-group-item').removeClass('bg-danger').removeClass('bg-success').removeClass('g-color-white');
      $('.list-group-item').children('i').remove();
      $('.list-group-item').children('span').remove();
      $('#ordering_sortable1').randomize('li');
      }

      // init attempts area text
      attemptsRemain = numberAttempts - attempts;
      attemptFeedback();

      $('#ordering_attempts').html(attemptTxt);
    }

    $('#ordering_access').click(() => { $('#ordering_accessibleModal').modal('show'); });

    $('#ordering_q_check2').click(() => { 
      ordering_submitQuiz();
    });

    function ordering_submitQuiz() {
      const formData = {
        response: {
          orderingResponse: [],
        },
        resourceId,
        contentId,
        contentType: 'ordering',
        inCollection
      };
      $('#ordering_sortable1').children('li').children('i').remove();

      $('#ordering_sortable1').children('li').each((index, value) => {
        formData.response.orderingResponse.push({
          id: $(value).attr('id'),
          value: $(value).children('.item-text').html(),
        });
      });
      $.ajax({
        type: 'POST',
        url: '/access/content/evaluate',
        data: formData,
        dataType: 'json',
        encode: true,
      }).done((data) => {
        const result = (data && data.result && data.result.result)
          ? data.result.result : data.result;
        mark(result);

        if ($('#footer').length > 0) {
          const footerHeight = Number($('#footer').outerHeight(true));
          if ($('body').height() + footerHeight > $(window).height()) {
            $('#footer').css('position', 'inherit');
          }
        }

        $('html, body').animate({
          scrollTop: $('#ordering_fb_div').offset().top,
        }, 1000);

        // for resource collection assessment
        if (inCollection) {
          window.parent.clearAssessment(result.correct ? 1 : 0, formData, result);
        }
      })
      .fail(function(err) {
        if (err && err.responseJSON && err.responseJSON.message) {
          var errMsg = err.responseJSON.message;

          if (errMsg === 'content has expired') {
            $("#ordering_q_fb2")
              .removeClass("d-none");

            $("#ordering_q_fb2 .card-text")
              .html("Your Session has timed out")
              .append(
              `<p class="text-white">
                Your activity could not be evaluated because your session has timed out. This is likely because you are viewing multiple pieces of content at the same time. Please reload this activity and try again.
              </p>`
            );

            $("#ordering_q_new2")
              .css("display", "none");

            $("#ordering_q_check2")
              .css("display", "none");

            $("#q_skip2")
              .css("display", "none");

            $("html, body").animate({
              scrollTop: $("#ordering_fb_div").offset().top
            }, 1000);
          }
        }
      });	    
    }

    $('#ordering_q_new2').click(() => {
      // reset interface for another attempt
      $('body').scrollTop(0);
      $('.fixedElement').css({ position: 'relative', top: '0px' });
      newQuestion2('reset');
    });

    $('#ordering_show_answers').click(function showAnswers() {
      const self = $(this);
      const formData = {
        resourceId,
        contentId,
        contentType: 'ordering',
        inCollection,
        response: {
          getCorrect: true,
        },
      };

      $.ajax({
        type: 'POST',
        url: '/access/content/evaluate',
        data: formData,
        dataType: 'json',
        encode: true,
      }).done((data) => {
        const result = (data && data.result && data.result.result)
          ? data.result.result : data.result;
        const correctDiv = $('#correctAnswer');
        correctDiv.show();
        result.correctResponse.forEach((index, value) => {
          if (value === 0) {
            correctDiv.append(index);
          } else {
            correctDiv.append(` <i class="fa fa-arrow-right" aria-hidden="true"></i> ${index}`);
          }
        });
        self.addClass('d-none');
        $('#answerModal').modal('show');
      });
    });

    $('#q_exit2').click(() => {
      setTimeout(() => {
        window.history.back();
      }, 500);
    });

    newQuestion2('new');
  } // end startOrdering

  // randomize the order of elements from the passed selector
  // (draggables and droppable descriptions)
  $.fn.randomize = function (selector) {
    const $elems = selector ? $(this).find(selector) : $(this).children();
    const $parents = $elems.parent();
    $parents.each(function () {
      $(this).children(selector).sort(() => Math.round(Math.random()) - 0.5)
        .detach()
        .appendTo(this);
    });
    return this;
  };

  // init JQuery UI Sortable
  $(() => {
    $('ul.droptrue').sortable({
      connectWith: 'ul',
      cancel: '.ui-state-disabled',
      placeholder: 'dropPlaceHolder',
      receive: () => {},
    });
    $('#ordering_sortable1').disableSelection();
  });

  // event to handle when a list receives a new draggable
  $('#ordering_sortable1').on('sortreceive', function (event, ui) {
    $(this).append(ui.item);// force the new draggable to bottom of list
    $(this).trigger('sortupdate');// manually fire the UI event
    if ($(this).children().length > 1) {
      // force the first child back to the list on the left, limits 1 draggable to a droppable.
      $('#ordering_sortable1').append($(this).children(':first'));
    }
  });
  startOrdering();

  // give the list items a data index
  $('#ordering_sortable1 li').attr('ordering-dataindex', (i) => (i + 1));

  // add listener for ordering-dataindex on drag and drop
  $('#ordering_sortable1').sortable({
    stop: () => {
      $('#ordering_sortable1 li').attr('ordering-dataindex', (i) => (i + 1));
    },
  });

  function handleEnter(event) {
    if (event.which === 13) {
      this.click();
    }
  }

  $('#ordering_q_check2').keydown(handleEnter);
  $('#ordering_access').keydown(handleEnter);
  $('#ordering_q_new2').keydown(handleEnter);
  $('#ordering_show_answers').keydown(handleEnter);
  $('#q_exit2').keydown(handleEnter);

  $(document).ready(() => {
    // fix the content from 'jumping'
    if ($('#order_floater .row').outerHeight() > 0) {
      $('#order_floater').height($('#order_floater .row').outerHeight());
    }

    // set up and down arrow keys to move list item
    $(document).keydown((e) => {
      // down
      if (e.keyCode === 40) {
        if ($(':focus').attr('ordering-dataindex') < $('#ordering_sortable1 li').length) {
          e.preventDefault();
          const thisTab = $(':focus').attr('ordering-dataindex');
          const nextTab = parseInt($(':focus').attr('ordering-dataindex'), 10) + 1;
          const thisTabID = $(`[ordering-dataindex ="${thisTab}"]`).attr('id');
          const nextTabID = $(`[ordering-dataindex ="${nextTab}"]`).attr('id');
          $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'true');
          $(`[ordering-dataindex ="${nextTab}"]`).after($(`[ordering-dataindex ="${thisTab}"]`));
          $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'false');
          $(`#${thisTabID}`).attr('ordering-dataindex', nextTab);
          $(`#${nextTabID}`).attr('ordering-dataindex', thisTab);
          $(`#${thisTabID}`).focus();
          let feedback = `Item moved. New position in list: ${ $(`#${thisTabID}`).attr('ordering-dataindex')} of ${$('#ordering_sortable1 li').length}.`;
          $('#srLiveFeedback').html(feedback);
        }
      }
      // up
      if (e.keyCode === 38) {
        if (e.shiftKey) {
          $('[ordering-dataindex="1"]').focus();
        } else if ($(':focus').attr('ordering-dataindex') > 1) {
          e.preventDefault();
          const thisTab = $(':focus').attr('ordering-dataindex');
          const prevTab = parseInt($(':focus').attr('ordering-dataindex'), 10) - 1;
          const thisTabID = $(`[ordering-dataindex ="${thisTab}"]`).attr('id');
          const prevTabID = $(`[ordering-dataindex ="${prevTab}"]`).attr('id');
          $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'true');
          $(`[ordering-dataindex ="${thisTab}"]`).after($(`[ordering-dataindex ="${prevTab}"]`));
          $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'false');
          $(`#${thisTabID}`).attr('ordering-dataindex', prevTab);
          $(`#${prevTabID}`).attr('ordering-dataindex', thisTab);
          let feedback = `Item moved. New position in list: ${ $(`#${thisTabID}`).attr('ordering-dataindex')} of ${$('#ordering_sortable1 li').length}.`;
          $('#srLiveFeedback').html(feedback);
        }
      }
    });

    // move items using up and down arrows on screen
    $('.sort-up').click((e) => {
      if ($(e.target).closest('.list-group-item').attr('ordering-dataindex') > 1) {
        e.preventDefault();
        const thisTab = $(e.target).closest('.list-group-item').attr('ordering-dataindex');
        const prevTab = parseInt($(e.target).closest('.list-group-item').attr('ordering-dataindex'), 10) - 1;
        const thisTabID = $(`[ordering-dataindex ="${thisTab}"]`).attr('id');
        const prevTabID = $(`[ordering-dataindex ="${prevTab}"]`).attr('id');
        $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'true');
        $(`[ordering-dataindex ="${thisTab}"]`).after($(`[ordering-dataindex ="${prevTab}"]`));
        $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'false');
        $(`#${thisTabID}`).attr('ordering-dataindex', prevTab);
        $(`#${prevTabID}`).attr('ordering-dataindex', thisTab);
        let feedback = `Item moved. New position in list: ${ $(`#${thisTabID}`).attr('ordering-dataindex')} of ${$('#ordering_sortable1 li').length}.`;
        $('#srLiveFeedback').html(feedback);
      }
    });

    $('.sort-down').click((e) => {
      if ($(e.target).closest('.list-group-item').attr('ordering-dataindex') < $('#ordering_sortable1 li').length) {
        e.preventDefault();
        const thisTab = $(e.target).closest('.list-group-item').attr('ordering-dataindex');
        const nextTab = parseInt($(e.target).closest('.list-group-item').attr('ordering-dataindex'), 10) + 1;
        const thisTabID = $(`[ordering-dataindex ="${thisTab}"]`).attr('id');
        const nextTabID = $(`[ordering-dataindex ="${nextTab}"]`).attr('id');
        $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'true');
        $(`[ordering-dataindex ="${nextTab}"]`).after($(`[ordering-dataindex ="${thisTab}"]`));
        $(`[ordering-dataindex ="${thisTab}"]`).attr('aria-grabbed', 'false');
        $(`#${thisTabID}`).attr('ordering-dataindex', nextTab);
        $(`#${nextTabID}`).attr('ordering-dataindex', thisTab);
        let feedback = `Item moved. New position in list: ${ $(`#${thisTabID}`).attr('ordering-dataindex')} of ${$('#ordering_sortable1 li').length}.`;
        $('#srLiveFeedback').html(feedback);
      }
    });


    $(window).resize(() => {
      if ($('#order_floater .row').outerHeight() > 0) {
        $('#order_floater').height($('#order_floater .row').outerHeight());
      }
    });

    $('#ordering_accessibleModal').on('shown.bs.modal', () => {
      $('#accessibilityModalCloseBtn').focus();
    });

    $('#ordering_accessibleModal').on('hidden.bs.modal', () => {
      $("#ordering_access").focus();
    });
  });
} // end init
